import { environment } from 'src/environments/environment';

export const selectedLangKey = 'selected_lang';
export const foaCarouselConfig = {
  loop: false,
  touchDrag: true,
  dots: false,
  lazyLoad: true,
  autoHeight: true,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  skip_validateItems: true,
  navText: ['<div class=\'favorite-list-card-arrow favorite-list-card-arrow-prev\'></div>',
    '<div class=\'favorite-list-card-arrow favorite-list-card-arrow-next\'></div>'],
  responsive: {
    0: {
      items: 2,
      nav: false
    },
    660: {
      items: 4,
      nav: false
    },
    1024: {
      items: 5,
      nav: true,
    },
    1199: {
      items: 5,
      nav: true,
    }

  }
};

export const productDetailImageCarouselConfig = {
  items: 1,
  loop: false,
  lazyLoad: true,
  touchDrag: true,
  nav: false,
  dots: false,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  skip_validateItems: true,
  responsive: {
    0: {
      dots: true
    },
    440: {
      dots: false
    }
  }
};
export const inStockStyle = '--available';
export const outOfStockStyle = '--outOfStock';
export const comingSoonStyle = '--soon';
export const onShopStyle = '--onShop';
export const backOrderStyle = '--backOrder';
export const hdDeliveryMode = 'Home Delivery';
export const BACKORDER_STATUS = 'BO';
export const maxEntryQuantity = 99;
export const countryCode = environment.appCountryCode;
export const countryName = environment.appCountryName;
export const affiliateCode = environment.affiliateCode;
export const cartUserId = 'anonymous';
export const memberKey = 'member';
export const aboKey = 'abo';
export const foaKey = 'foa';
export const noneFoaKey = 'none';
export const maxAllowedFileSizeInBytes = 5000000;
export const allowedUploadImageExt = ['.jpg', '.jpeg', '.png'];
export const invalidPromoCodeErrorCode = 'ecom-val-cart-1016';
export const duplicateCidErrorCodes = ['-201224','-201207'];
// abo/mem/foa/abo within cooling/mem within cooling
export const duplicatePhoneNumbers = ['-200652', '-200649', '-200647', '200654', '-200651'];
export const thaiCalendarYrs = 543;
export const sharebarListType = 'list';
export const pdp = 'pdp';
export const shopInfo = 'shopInfo';
export const minFoaProductQty = 1;
export const maxFoaProductQty = 6;
export const amwaysite = 'Amway Thailand Site';
export const inactive = 'INACTIVE';
export const SHARE_TYPES = {
  fb: 'facebook',
  line: 'line',
  email: 'email',
  link: 'link'
};
export const CITIZEN_TYPES = {
  citizen: 'Citizen',
  foreigner: 'Foreigner'
};
export const IDENTITY_TYPE = {
  cid: 'CID',
  pid: 'PID'
};
export const BUSINESS_NATURE = {
  member: 'AmwayBusinessNature_3',
  abo: 'AmwayBusinessNature_1',
  foa: 'AmwayBusinessNature_9'
};
export const foaCartBusinessNature = 'GuestCustomer';
export const foaServiceProductSkus = ['306548', '282201', '254998', '254966', '291580', '282202', '307809'];
export const foaRegistrationSku = '306548';
export const contractIds = {
  foa: [
    { contractId: '340005', contractType: 'LegalConsent', label: 'REGISTRATION.privacy_policy', text: 'REGISTRATION.privacy_policy_text' },
    { contractId: '340004', contractType: 'Registration', label: 'REGISTRATION.terms_and_conditions', text: '' }],
  abo: [
    { contractId: '330003', contractType: 'LegalConsent', label: 'REGISTRATION.privacy_policy', text: 'REGISTRATION.privacy_policy_text' },
    { contractId: '170034', contractType: 'Registration', label: 'REGISTRATION.terms_and_conditions', text: '' }],
  member: [
    { contractId: '330003', contractType: 'LegalConsent', label: 'REGISTRATION.privacy_policy', text: 'REGISTRATION.privacy_policy_text' },
    { contractId: '170049', contractType: 'Registration', label: 'REGISTRATION.terms_and_conditions', text: '' }]
};
export const stockUnavailableStyles = [outOfStockStyle, onShopStyle, comingSoonStyle];
export const priorityStockStyles = [outOfStockStyle, onShopStyle, comingSoonStyle, backOrderStyle, inStockStyle];
export const cidHyphenIndexes = [1, 6, 12, 15];
export const phoneHyphenIndexes = [3, 7];
export const defaultPaginationSize = 5;
export const defaultProductSearchPaginationSize = 50;
export const fbUrl = 'https://www.facebook.com/';
export const youtubeUrl = 'https://www.youtube.com/user/';
export const instaUrl = 'https://www.instagram.com/';
export const twitterUrl = 'https://www.twitter.com/';
export const tiktokUrl = 'https://www.tiktok.com/';
